export default [
    {
        path: '/currencies',
        name: 'currencies',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Currencies.vue')
    }
]